import { LEDGER_ENTRIES } from '@/legacy/mocks/seed';
import { DEMO_SCENARIOS, useStore } from '@/legacy/store';
import type { SellerServices, SellerSnapshot } from '../sellerContracts';

export const mockSellerServices: SellerServices = {
  async snapshot(): Promise<SellerSnapshot> {
    const s = useStore.getState();
    const scenario = DEMO_SCENARIOS.find((x) => x.id === s.scenarioId);
    const sellerId = scenario?.sellerId;
    const seller = s.sellers.find((x) => x.id === sellerId) ?? s.sellers[0];
    const orders = s.orders.filter((o) => o.items.some((i) => i.sellerId === seller.id));
    return {
      seller: {
        id: seller.id, name: seller.name, email: seller.email, slug: seller.slug,
        status: seller.status, commissionBps: seller.commissionBps, phone: seller.phone, createdAt: seller.createdAt,
      },
      orders: orders.map((o) => ({
        id: o.id, number: o.number, customerName: o.customerName, grandTotal: o.grandTotal,
        status: o.status, fulfillmentStatus: o.fulfillmentStatus ?? 'unallocated', createdAt: o.createdAt,
        items: o.items.map((i) => ({
          productId: i.productId, name: i.productName, price: i.unitPrice, quantity: i.qty, sellerId: i.sellerId,
        })),
      })),
      offers: s.products.filter((p) => p.sellerId === seller.id).map((p) => ({
        id: p.id, name: p.name, sku: p.sku, price: p.price, stock: p.stock, status: p.status,
      })),
      ledger: LEDGER_ENTRIES.filter((e) => e.sellerId === seller.id).map((e) => ({
        id: e.id, type: e.type, amount: e.amount, balance: e.balance ?? 0, description: e.description, createdAt: e.createdAt,
      })),
      payouts: s.payouts.filter((p) => p.sellerId === seller.id).map((p) => ({
        id: p.id, amount: p.amount, status: p.status, method: p.method,
        periodStart: p.periodStart, periodEnd: p.periodEnd, processedAt: p.processedAt ?? p.releasedAt,
      })),
      rmas: s.rmas.filter((r) => r.sellerId === seller.id).map((r) => ({
        id: r.id, number: r.id, customerName: r.customerName ?? '', reason: r.reason ?? r.items[0]?.reason ?? '', status: r.status,
      })),
      balance: 0,
    };
  },
  async transition() { /* demo mutations stay on the Zustand store */ },
  async updateProfile() { return (await this.snapshot()).seller; },
  async requestPayout() { /* demo */ },
  async rmaAction(id, status) { useStore.getState().updateRmaStatus(id, status as 'requested'); },
};
